// GiftCertificate/GiftCertificateActivationPage.tsx

import React, {ChangeEvent, useState} from 'react';
import Button from 'Core/components/elements/Button/Button';
import {Message} from 'Core/components/Message';
import {axios} from "Auth/axiosConfig";
import {useErrorProcessing} from "Core/components/ErrorProvider";
import TextField from "Core/components/elements/TextField/TextField";
import {FCCC, FRCC} from "WideLayout/Layouts";
import {useNavigate} from "react-router-dom";

const GiftCertificateActivationPage: React.FC = () => {
    const [keyInput, setKeyInput] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const {byResponse} = useErrorProcessing();
    const navigate = useNavigate();
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        setKeyInput(e.target.value);
    };

    const handleActivate = async () => {
        if (!keyInput) {
            Message.error('Введите ключ сертификата');
            return;
        }
        setLoading(true);
        try {
            await axios.post('/api/v1/gift-certificate/activate/', {key: keyInput});
            Message.success('Сертификат активирован');
            navigate('/consultations')
        } catch (e) {
            byResponse(e)
        } finally {
            setLoading(false);
        }
    };

    return (
        <FCCC g={1} px={2} m={'auto'} mt={'20vh'} cls={'gift-certificate-activation-page'} maxW={495}>
            <FRCC component={'h4'} textAlign={'center'} m={0}>
                Активация подарочного сертификата
            </FRCC>
            <TextField
                label="Ключ сертификата"
                variant="outlined"
                value={keyInput}
                onChange={handleChange}
                fullWidth
            />
            <Button sx={{px: 2, pt: 1, letterSpacing: '.2rem'}} onClick={handleActivate} loading={loading}
                    color={'primary'}>
                Активировать
            </Button>
        </FCCC>
    );
};

export default GiftCertificateActivationPage;
